<yat-polling-status id="7506e36b-f388-4366-b378-e075cc769511" [configuration]="extendedConfiguration">{{ pollText }}</yat-polling-status>

<p class="c-gray text-center mt-2 font-small" *ngIf="!proceeding">
  <a class="c-gray" [routerLink]="null" (click)="cancelAuthentication()"> {{ 'cancel' | commonWording | async }} </a>
</p>
